module.exports = __webpack_public_path__ + "ipetbooking-landing/img/paw-1.146c6698.svg";